import * as types from './mutation-types';

export default {
    [types.SET_USER_ID](state, uid) {
        state.id = uid;
    },
    [types.SET_USER_AUTHENTICATION](state, isAuth) {
        state.isAuthenticated = isAuth;
    },
    [types.SET_USER_PROFIL](state, profil) {
        state.profil = profil;
    },
    [types.SET_USER_PERMISSIONS](state, permissions) {
        state.permissions = permissions;
    },
    [types.SET_USER](state, user) {
        state.id = user.id;
        state.profil = user.profil;
        state.permissions = user.permissions;
    },
};